import { ConfiguratorType } from '../../../baseBtl/catalog/products/interface/configurable';
import { PromotionBase } from '../../../baseBtl/checkout/cart/promotions/promotion.class';
import {
    IPRomotionAcquisition,
    IPRomotionCustomer,
    IPRomotionRenouvellement,
    IPromotionToTransform,
    IPromotions,
} from './promotion.interface';

export class Promotion extends PromotionBase {
    public static refactorJson(json: IPromotionToTransform[], type: string = 'basique'): IPromotions[] {
        const promotionsRefactored: IPromotions[] = [];
        let promotions: IPromotionToTransform[];
        switch (type) {
            case ConfiguratorType.PORTA:
                promotions = json.filter(
                    (promotionToTransform: IPromotionToTransform) =>
                        promotionToTransform.conditions.odr && promotionToTransform.conditions.geoloc === undefined,
                );
                break;
            case ConfiguratorType.LOCALES:
                promotions = json.filter(
                    (promotionToTransform: IPromotionToTransform) =>
                        promotionToTransform.conditions.odr && promotionToTransform.conditions.geoloc,
                );
                break;
            case ConfiguratorType.CONVERGENCE:
                promotions = json;
                break;
            case ConfiguratorType.CUSTOMER:
                promotions = json.filter(
                    (promotionToTransform: IPromotionToTransform) =>
                        !promotionToTransform.conditions.odr &&
                        !promotionToTransform.conditions.geoloc &&
                        promotionToTransform.conditions.type_client.includes('customer'),
                );
                break;
            default:
                promotions = json.filter(
                    (promotionToTransform: IPromotionToTransform) =>
                        !promotionToTransform.conditions.odr &&
                        !promotionToTransform.conditions.geoloc &&
                        promotionToTransform.conditions.type_client.includes('prospect'),
                );
        }

        promotions.forEach((promotion: IPromotionToTransform) => {
            const conditions = {
                statut: promotion.conditions.status,
                contrats: promotion.conditions.contracts,
                incitation: { enabled: promotion.incitation.enabled, banner: promotion.incitation.banner },
            };
            const client: IPRomotionCustomer = promotion.conditions.type_client.includes('customer')
                ? conditions
                : null;
            const acquisition: IPRomotionAcquisition = promotion.conditions.type_client.includes('prospect')
                ? conditions
                : null;
            const renouvellement: IPRomotionRenouvellement = {};
            const promotionRefactored: IPromotions = {
                name: promotion.promo_name,
                produitsVisibles: promotion.visible_products_id,
                produits: promotion.products,
                titre: promotion.label,
                description: promotion.description,
                reduction: promotion.discount_amount,
                duree: promotion.duration,
                delai: promotion.offset,
                unicite: promotion.uses_per_customer,
                debut: promotion.dates.start,
                fin: promotion.dates.end,
                id: promotion.rule.id,
                incitation: promotion.incitation.label,
                label_if_eligible: promotion.label_if_eligible,
                conditions: {
                    client,
                    acquisition,
                    renouvellement,
                    catalogOperator: promotion.conditions.catalog_operator,
                    callOperator: promotion.conditions.call_operator,
                },
            };
            if (promotion.conditions.fai_promo_postal_code) {
                promotionRefactored.conditions.promo_postal_code = promotion.conditions.fai_promo_postal_code;
            }
            promotionsRefactored.push(promotionRefactored);
        });
        return promotionsRefactored;
    }
}
